import {
    CLEAR_PROTEST,
    FETCH_PROTEST,
    LIST_PROTEST,
    MODIFIED_PROTEST,
} from "./types";

const init = {
    isLoading: false,
    list: [],
    filter: {},
    page: 1,
    totals: 0,
    size: 50
};

export default (state = init, {type, payload}) => {
    switch (type) {
        case FETCH_PROTEST:
            return {
                ...state,
                filter: payload,
                isLoading: true
            };
        case LIST_PROTEST:
            return {
                ...state,
                isLoading: false,
                list: payload.data,
                ...payload.paging
            };
        case CLEAR_PROTEST:
            return {
                isLoading: false,
                list: []
            };
        case MODIFIED_PROTEST:
            return {
                ...state,
                isLoading: true
            };
        default:
            return state;
    }
}